/** 
 * @param {string} pageName Unique id of the page
 * @param {bool} isVisible Should the page be rendered?
 * @param {string} pageHeaderTitle
 * @param {string} pageHeaderDescription
 * @param {elements} children
 * @param {elements} errorMessage
 * @param {string} errorHeaderTitle
 * @param {bool} showError
*/
function SegmentPage(props) {

	let pageDescription = null;
	if (props.pageHeaderDescription !== undefined && props.pageHeaderDescription !== null && props.pageHeaderDescription !== "") {
		pageDescription = <p className="book-meeting__textwrapper">{props.pageHeaderDescription}</p>
	}

	let isVisibleClass = "";
	if(props.isVisible === false){
		isVisibleClass = "hidden";
	}

	let errorMessage = props.errorMessage === undefined ? null : props.errorMessage

	return (
		<section id={props.pageName} className={"row segmentPage " + isVisibleClass}>
			<header className="book-meeting__header">
				{props.breadCrumbs}				
					<h2 className="heading">{props.showError ? props.errorHeaderTitle : props.pageHeaderTitle}</h2>
					{pageDescription}
			</header>

			<div className="segmentPageMainContent">
				{props.showError ? errorMessage : props.children}
			</div>

		</section>
	);
}

export default SegmentPage;